import ModalGlobalTopbar from "../modalGlobalTopbar/ModalGlobalTopbar";
import { useEffect, useRef, useState } from "react";
import style from "./ModalApps.module.css";
import TopbarItem from "./modalAppsItem/ModalAppsItem";
import { FaGraduationCap, FaLaptop } from "react-icons/fa";

function ModalApps({ mostrar, aoFechar, botaoRef }) {
  const modalRef = useRef(null);
  const [posicao, setPosicao] = useState({ top: 0, left: 0 });

  // Função para calcular a posição do modal
  const calcularPosicao = () => {
    if (botaoRef.current) {
      const rect = botaoRef.current.getBoundingClientRect();
      setPosicao({
        top: rect.bottom + 5, // 5px de margem abaixo do botão
        left: rect.right - 330, // Ajusta para alinhar à direita do botão
      });
    }
  };

  useEffect(() => {
    if (mostrar) {
      calcularPosicao(); // Atualiza a posição ao abrir

      // Atualiza a posição ao redimensionar a janela
      window.addEventListener("resize", calcularPosicao);
    }

    return () => {
      window.removeEventListener("resize", calcularPosicao);
    };
  }, [mostrar]); // Recalcula sempre que o modal for mostrado


  return (
    <ModalGlobalTopbar mostrar={mostrar} aoFechar={aoFechar}>
      <div
        ref={modalRef}
        className={style.container_modal}
        style={{ top: `${posicao.top}px`, left: `${posicao.left}px` }}
      >
        <div className={style.container_caminhos}>
          <TopbarItem
            link={process.env.REACT_APP_BACKOFFICE}
            texto={"Painel Itera360"}
            logo={<FaLaptop />}
          />
          <TopbarItem
            link={process.env.REACT_APP_PLATAFORMA}
            texto={"Plataforma"}
            logo={<FaGraduationCap />}
          />
        </div>
      </div>
    </ModalGlobalTopbar>
  );
}

export default ModalApps;
